module.exports = __webpack_public_path__ + "static/img/pointer.241d6ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pointer.png
// module id = iEQ4
// module chunks = 1